import { owcTheme } from 'core/theme/theme.config';
import styled from 'styled-components';
import { DatePicker } from '../date-picker.component';

const DATE_RANGE_WIDTH_FACTOR = 2.8;

export const DateRangeDatePicker = styled(DatePicker)`
    min-width: calc(${owcTheme['one-spacer-px-100']} * ${DATE_RANGE_WIDTH_FACTOR});
`;
